/* eslint-disable react-hooks/exhaustive-deps */
const { useEffect, useState } = require('react');
const { useNavigate, useLocation } = require('react-router-dom');

function useHashHandler(hash, startup) {
  const navigate = useNavigate();
  const location = useLocation();

  const [actualFolder, setActualFolder] = useState(null);

  useEffect(() => {
    if (hash) {
      const newHash = actualFolder?.id !== `root.startup.${startup.id}` ? actualFolder?.id : '';
      if (actualFolder?.id && location.hash.slice(1) !== newHash) {
        navigate({ hash: newHash, search: actualFolder?.name ? `?name=${actualFolder?.name}` : '' });
      }
    }
  }, [actualFolder, startup.id]);

  useEffect(() => {
    if (hash) {
      const hashId = location.hash ? location.hash.slice(1) : `root.startup.${startup.id}`;
      if (actualFolder?.id !== hashId) {
        setActualFolder({ id: hashId, name: decodeURIComponent(location.search.split('=')[1]) });
      }
    }
  }, [location.hash, startup.id]);

  return [actualFolder, setActualFolder];
}

export default useHashHandler;
